import React from 'react';
import type { BeerStatus } from '../api/types';

const STATUS_CFG: Record<BeerStatus, { label: string; style: React.CSSProperties }> = {
  active:  { label: 'ACTIVE',  style: { borderColor: 'var(--text)',   background: 'transparent',      color: 'var(--text)' } },
  pending: { label: 'PENDING', style: { borderColor: 'var(--border)', background: 'var(--bg-subtle)', color: 'var(--text-muted)' } },
  retired: { label: 'RETIRED', style: { borderColor: 'var(--border)', background: 'transparent',      color: 'var(--text-subtle)' } },
};

export function BeerStatusBadge({ status }: { status: BeerStatus }) {
  const { label, style } = STATUS_CFG[status];
  return (
    <span style={{
      display: 'inline-block', padding: '2px 8px', borderRadius: 4,
      fontSize: '0.6875rem', fontWeight: 700, letterSpacing: '0.08em',
      border: '1px solid', flexShrink: 0,
      ...style,
    }}>{label}</span>
  );
}
